import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { provideRouter } from "@angular/router";

// Local file
import { routes } from './routes';


@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    provideRouter(routes),
  ]
})
export class WagerFeatureIonModule {}


/**
 * Export component to be use outside
 */
export * from './components/matrix/matrix.component';
export * from './components/results-menu/results-menu.component';
export * from './components/play-video/play-video.component';
